import {FeatureName} from '@contentlab/types/project';
import {
  CONTENT_LAB_VIEW_NAMES,
  FLOW_NAMES,
} from '@/lib/analytics/analyticsConstants';
import translate from '@/utils/translate';

export const interactionLocationForFeature = (feature: FeatureName) => {
  switch (feature) {
    case FeatureName.REPHRASING:
      return CONTENT_LAB_VIEW_NAMES.REPHRASE;
    case FeatureName.REFORMATTING:
      return CONTENT_LAB_VIEW_NAMES.RESIZE;
    case FeatureName.AI_DUBBING:
      return CONTENT_LAB_VIEW_NAMES.DUB;
    case FeatureName.CAPTIONS:
      return CONTENT_LAB_VIEW_NAMES.CAPTIONS;
    case FeatureName.AI_AVATAR:
      return CONTENT_LAB_VIEW_NAMES.AI_AVATAR;
    default:
      return CONTENT_LAB_VIEW_NAMES.RESIZE;
  }
};

export const flowNameForFeature = (feature: FeatureName) => {
  switch (feature) {
    case FeatureName.REPHRASING:
      return FLOW_NAMES.CONTENT_LAB.REPHRASE;
    case FeatureName.REFORMATTING:
      return FLOW_NAMES.CONTENT_LAB.RESIZE;
    case FeatureName.AI_DUBBING:
      return FLOW_NAMES.CONTENT_LAB.DUB;
    case FeatureName.CAPTIONS:
      return FLOW_NAMES.CONTENT_LAB.CAPTIONS;
    case FeatureName.AI_AVATAR:
      return FLOW_NAMES.CONTENT_LAB.AI_AVATAR;
    default:
      return FLOW_NAMES.CONTENT_LAB.RESIZE;
  }
};

export const creditsTooltipTextForFeature = (
  feature: FeatureName,
  uploadedVideosCount: number,
  selectedUserInputCount: number
) => {
  switch (feature) {
    case FeatureName.REPHRASING:
      return translate(
        'Each 30s segment of a video file (or the rest of it) costs 1 video credit.'
      );
    case FeatureName.REFORMATTING:
      return `${translate(
        'Each 30s segment of a video file (or the rest of it) costs 1 video credit.'
      )} ${translate('credits_tooltip_video_count', {
        count: uploadedVideosCount,
      })} ${translate('credits_tooltip_user_input_count', {
        count: selectedUserInputCount,
        user_input: translate('aspect ratio'),
      })}.`;
    case FeatureName.AI_DUBBING:
      return `${translate(
        'Each 30s segment of a video file (or the rest of it) costs 1 video credit.'
      )} ${translate('credits_tooltip_video_count', {
        count: uploadedVideosCount,
      })} ${translate('credits_tooltip_user_input_count', {
        count: selectedUserInputCount,
        user_input: translate('language'),
      })}.`;
    case FeatureName.CAPTIONS:
      return `${translate(
        'Each 30s segment of a video file (or the rest of it) costs 1 video credit.'
      )} ${translate('credits_tooltip_video_count', {
        count: uploadedVideosCount,
      })} ${translate('credits_tooltip_user_input_count', {
        count: selectedUserInputCount,
        user_input: translate('language'),
      })}.`;
    case FeatureName.AI_AVATAR:
      return `${translate(
        'Each 30s segment of a video file (or the rest of it) costs 1 video credit.'
      )}.`;
    case FeatureName.UPSCALE:
      return `${translate(
        'Each 30s segment of a video file (or the rest of it) costs 1 video credit.'
      )} ${translate('credits_tooltip_video_count', {
        count: uploadedVideosCount,
      })} ${translate('credits_tooltip_user_input_count', {
        count: selectedUserInputCount,
        user_input: translate('resolution'),
      })}.`;
    default:
      return '';
  }
};
